import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

export default function Breadcrumb() {
  const location = useLocation();

  const getBreadcrumbs = (): BreadcrumbItem[] => {
    const path = location.pathname;
    const crumbs: BreadcrumbItem[] = [{ label: '首页', path: '/' }];

    if (path === '/about') {
      crumbs.push({ label: '关于我们' });
    } else if (path === '/category') {
      crumbs.push({ label: '分类浏览' });
    } else if (path.startsWith('/article/')) {
      crumbs.push({ label: '分类浏览', path: '/category' });
      crumbs.push({ label: '文章详情' });
    }

    return crumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <nav aria-label="面包屑导航" className="bg-background-100/60 border-b border-background-200/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center gap-1.5 text-sm flex-wrap">
          {breadcrumbs.map((crumb, index) => (
            <li key={index} className="flex items-center gap-1.5">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs" />
              )}
              {crumb.path && index < breadcrumbs.length - 1 ? (
                <Link
                  to={crumb.path}
                  className="text-foreground-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-foreground-800 font-medium whitespace-nowrap">
                  {crumb.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}